import { useContext, useEffect, useState } from 'react'
import { VersionHistoryContext } from '../../context/versionHistoryContext'
import './Title.scss'

export const Title = () => {
    const { state } = useContext(VersionHistoryContext);

    const [date, setDate] = useState(null);
    const [version, setVersion] = useState(null);

    useEffect(() => {
        if (state.selectedVersion) {
            setDate(state.selectedVersion.formatedDate);
            setVersion(state.selectedVersion.versionNumber);
        }
    }, [state.selectedVersion])

    return (
        <div className='history-title'>
            <div className='title-preview'>Preview</div>
            {state.selectedVersion && <div className='date'>{date}, Version {version} of {state.total}</div>}
        </div>
    )
}
